import elementIUMessage from 'element-ui/lib/message.js';
import LaravelRouter from "../thirdparty/Ziggy/route";
import moment from 'moment-timezone';

export {
    downloadText,
    ucfirst,
    splitObjKey,
    objLookup,
    handleHttpError,
    getExceptionErrorMessage,
    getHttpValidationErrors,
    numberWithCommas,
    submitHiddenForm,
    objToUrl,
    parseUrl,
    nl2br,
    laravelRoute,
    searchDataFromModel,
    arrayRemove,
    arrayChunk,
    setBackToAll,
    getBackToAll,
    storeLocalData,
    getLocalData,
    storeSessionData,
    getSessionData,
    saveVuexState,
    getVuexState,
    getDate,
    getTime,
    getTimeAgo,
    getDateTime,
    getNZDateTime,
    getJapanDiff,
    saveLastUrl,
    getLastUrl,
    makeID,
    hashString,
    addPageUrlParam,
    addToUrlQuery,
    slugify
};
function ucfirst(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}

function slugify(str){
    if (str) {
        return str
            .toLowerCase()
            .trim()
            .replace(/[^\w\s-]/g, '')
            .replace(/[\s_-]+/g, '-')
            .replace(/^-+|-+$/g, '');
    }
    return '';
}

function arrayChunk (arr, size) {
    return Array.from({length: Math.ceil(arr.length / size)}, (v, i) =>
        arr.slice(i * size, i * size + size)
    )
}

function saveVuexState (key, state) {
    state.isFromSessionStorage = true

    window.sessionStorage.setItem(key, JSON.stringify({ state, expiration: Date.now() + 8 * 3600 * 1000 }))
}
function getVuexState (name, defaultState) {
    let storedState = window.sessionStorage.getItem(name)
    let state
    if (storedState) {
        try {
            let newState = JSON.parse(storedState)
            if (newState && newState.state && newState.expiration && newState.expiration > Date.now()) {
                state = newState.state
            } else {
                state = null
            }
        } catch (e) {
            state = null
        }
    }
    if (state) {
        for (const key in defaultState) {
            if (Object.prototype.hasOwnProperty.call(defaultState, key) && typeof state[key] === 'undefined') {
                state[key] = defaultState[key]
            }
        }
    } else {
        state = defaultState
    }
    return state;
}

/**
 * @param string
 * @returns {number}
 */
function hashString (string) {
    let hash = 0;
    if (string.length === 0) {
        return hash;
    }
    for (let i = 0; i < string.length; i++) {
        let char = string.charCodeAt(i);
        hash = ((hash<<5)-hash)+char;
        hash = hash & hash; // Convert to 32bit integer
    }
    return hash;
}
function makeID(length, include_lower, include_similar) {
    let result           = '';
    let characters       = 'ABCDEFGHJKLMNPQRSTUVWXYZ123456789'
    let similar = 'IO0'
    let lower = 'abcdefghijklmnopqrstuvwxyz'
    if (include_lower) {
        characters = characters + lower;
    }
    if (include_similar) {
        characters = characters + similar;
    }
    let charactersLength = characters.length;
    for (let i = 0; i < length; i++ ) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
}

function getDate(data) {
    return moment(data).format(defaultMomentDateFormat())
}
function getTime(data, format = 'HH:mm') {
    return moment(data).format(format)
}

function getTimeAgo(data, short = true) {
    const ago = moment(data).fromNow();
    if (short) {
        return ago.replace('minute', 'min').replace('second', 'sec').replace('hour', 'hr');
    }
    return ago;
}

function saveLastUrl() {
    let url = window.location.href
    return storeLocalData('last_url', url)
}

function getLastUrl() {
    return getLocalData('last_url')
}

function parseUrl (path){
    let hash = ''
    let query = ''

    const hashIndex = path.indexOf('#')
    if (hashIndex >= 0) {
        hash = path.slice(hashIndex)
        path = path.slice(0, hashIndex)
    }

    const queryIndex = path.indexOf('?')
    if (queryIndex >= 0) {
        query = path.slice(queryIndex + 1)
        path = path.slice(0, queryIndex)
    }

    return {
        path,
        query: parseUrlQuery(query),
        hash
    }
}

function parseUrlQuery (query) {
    const res = {}

    query = query.trim().replace(/^(\?|#|&)/, '')

    if (!query) {
        return res
    }

    query.split('&').forEach(param => {
        const parts = param.replace(/\+/g, ' ').split('=')
        const key = decodeURIComponent(parts.shift())
        const val = parts.length > 0
            ? decodeURIComponent(parts.join('='))
            : null

        if (res[key] === undefined) {
            res[key] = val
        } else if (Array.isArray(res[key])) {
            res[key].push(val)
        } else {
            res[key] = [res[key], val]
        }
    })

    return res
}

function splitObjKey(key) {
    let type = typeof key;
    if (type == "string" || type == "number") {
        key = ("" + key).replace(/\[(.*?)\]/g, function (m, key) { //handle case where [1] or ['xa'] may occur
            return "." + key.replace(/^["']|["']$/g, ""); //strip quotes at the start or end of the key
        }).split(".");
    }
    return key;
}

function nl2br (str) {
    if (typeof str === 'undefined' || str === null) {
        return '';
    }
    var breakTag = '<br />';
    return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2');
}

function objLookup(obj, key) {
    key = splitObjKey(key);
    let i = 0, length;
    for (length = key.length; i < length; i++) {
        if (_.has(obj, key[i])) obj = obj[key[i]];
        else return void 0;
    }
    return obj;
}

function toCssClass(input) {
    if (!Array.isArray(input)) {
        input = input.split(',')
    }
    input.forEach(item => {

    });
}

function getExceptionErrorMessage(e) {
    if (typeof e === 'string') {
        return e;
    }
    let message = objLookup(e, 'response.data.message');
    if (!message) {
        message = objLookup(e, 'data.message');
    }
    if (!message) {
        message = objLookup(e, 'message');
    }
    if (!message) {
        message = 'There was a problem with your request.';
    }
    return message;
}

function numberWithCommas(x, ifOver = 0) {
    if (x > ifOver) {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
    return x
}

function downloadText(filename, text) {
    var element = document.createElement('a');
    element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(text));
    element.setAttribute('download', filename);

    element.style.display = 'none';
    document.body.appendChild(element);

    element.click();

    document.body.removeChild(element);
}

function getHttpValidationErrors(e) {
    if (typeof e === 'string') {
        return {general: [e]};
    }
    let errors = objLookup(e, 'errors');
    if (errors) {
        return errors;
    }
    errors = objLookup(e, 'response.data.errors');
    if (errors) {
        return errors;
    }
    return false;
}

function handleHttpError(e) {
    let message = getExceptionErrorMessage(e);
    if (message) {
        elementIUMessage.error(message);
    }
}

function getDateTime(data) {
    let time = moment(data)
    return time;
}
function getNZDateTime(date) {
    let nzdate = moment.tz(date, 'Asia/Tokyo')
    nzdate.tz('Pacific/Auckland')
    return nzdate;
}
function getJapanDiff(date) {
    let time = getNZDateTime(date)
    let now = moment.tz('Pacific/Auckland');
    let diff = now.diff(time, 's');
    let string = '';
    if (diff) {
        let left = Math.abs(diff);
        let timeframes = {
            'day': 86400,
            'hr': 3600,
            'min': 60,
        }
        for (let t in timeframes) {
            let val = Math.floor(left / timeframes[t]);
            if (val > 0) {
                string += ' ' + val + ' ' + t
                left = time % timeframes[t]
            }
        }
        if (time < now) {
            string = 'DONE: ' + string + 's ago'
        } else {
            string = string + 's from now'
        }
    }
    return string;
}

/**
 * @param url action of the form
 * @param fields object {field_name => 'value'}
 * @param method HTTP method
 */
function submitHiddenForm(url, fields = null, method = 'POST') {
    let form = document.createElement('form');
    form.action = url;
    form.method = method;
    form.style = 'display: none;';
    let token = document.head.querySelector('meta[name="csrf-token"]');

    if (token) {
        if (!fields) {
            fields = {'_token': token.content}
        } else {
            fields._token = token.content;
        }
    } else {
        console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
    }
    if (fields) {
        for (let field in fields) {
            let element = document.createElement('input');
            element.type = 'hidden';
            element.name = field;
            element.value = fields[field];
            form.appendChild(element);
        }
    }
    document.body.appendChild(form);
    form.submit();
}

function setBackToAll(url) {
    return storeSessionData('backToAll', url)
}
function getBackToAll() {
    return getSessionData('backToAll')
}

/**
 *
 * @param key
 * @param data
 * @param expires Expiry in minutes
 */
function storeLocalData(key, data, expires = null){
    let json = JSON.stringify(data);
    if (window.localStorage) {
        try {
            window.localStorage.setItem(key, json);
            if (expires) {
                let millis = moment().add(expires, 'm').format('x');
                if (millis) {
                    window.localStorage.setItem(key + '_ex', millis);
                }
            }
            return true;
        } catch (e) {
            console.warn('Exception in storeLocalData(): ', e)
        }
    }
    return false;
}

/**
 *
 * @param url
 * @param params object
 * @returns {string}
 */
function addToUrlQuery(url, params){
    if (url.indexOf('?') === -1){
        url = url + '?' + objToUrl(params)
    } else {
        const parsed = parseUrl(url)
        const args = Object.assign(parsed.query, params)
        url = parsed.path + '?' + objToUrl(args)
    }
    return url
}

function storeSessionData(key, data, expires = null){
    let json = JSON.stringify(data);
    if (window.sessionStorage) {
        try {
            window.sessionStorage.setItem(key, json);
            return true;
        } catch (e) {
            console.warn('Exception in storeLocalData(): ', e)
        }
    }
    return false;
}

function getLocalData(key){
    let data = null;
    if (window.localStorage) {
        try {
            let expires = window.localStorage.getItem(key + '_ex');
            let millis = moment().format('x');
            if (!expires || expires > millis) {
                let json = window.localStorage.getItem(key);
                if (json) {
                    data = JSON.parse(json);
                }
            }
        } catch (e) {
            console.warn('Exception in getLocalData(): ', e)
        }
    }
    return data;
}
function getSessionData(key){
    let data = null;
    if (window.sessionStorage) {
        try {
            let json = window.sessionStorage.getItem(key);
            if (json) {
                data = JSON.parse(json);
            }
        } catch (e) {
            console.warn('Exception in getLocalData(): ', e)
        }
    }
    return data;
}

/**
 * This will convert an object into a url recursively
 * eg: {filter:{dir:184},b:'a'} into "filter[dir]=188&b=a"
 * @param o
 * @returns {string}
 */
function objToUrl(o) {

    let iter = function (o, path) {
        if (Array.isArray(o)) {
            o.forEach(function (a) {
                iter(a, path + '[]');
            });
            return;
        }
        if (o !== null && typeof o === 'object') {
            Object.keys(o).forEach(function (k) {
                iter(o[k], path + '[' + k + ']');
            });
            return;
        }
        data.push(path + '=' + o);
    }

    let data = [];
    Object.keys(o).forEach(function (k) {
        iter(o[k], k);
    });
    return data.join('&');
}

function laravelRoute (name, args = [], abs = true) {
    let url = null;
    try{
        url =  LaravelRouter(name, args, abs).url();
    } catch(e) {
        console.warn(e);
    }
    return url;
};

/**
 * Remove a value from an array.
 *
 * @param array
 * @param value
 * @param new_array set to true if you don't want to affect the original array
 * @returns []
 */
function arrayRemove(array, value, new_array = false){
    let index = array.indexOf(value);
    if (index !== -1){
        if (new_array){
            let new_arr = JSON.parse(JSON.stringify(array));
            new_arr.splice(index, 1);
            return new_arr;
        } else {
            array.splice(index, 1);
            return array;
        }
    }
    return array;
}

/**
 * Prepares the search data for VehicleSearchForm vue component
 *
 * @param data a model from laravel SavedSearch || AutoNotice ||
 * @returns {*}
 */
function searchDataFromModel(data) {
    let tmp_data = JSON.parse(JSON.stringify(data));
    let searchdata = tmp_data.search;
    searchdata.id = tmp_data.id;
    searchdata.name = tmp_data.name;
    let exluded_makes = [];
    if (searchdata.exclude_make && searchdata.exclude_make.length) {
        searchdata.exclude_make.forEach(item => {
            exluded_makes.push(item.name);
        });
        searchdata.exclude_make = exluded_makes;
    }

    return searchdata;
}

function defaultMomentDateFormat () {
    return 'DD/MM/YYYY'
}

function addPageUrlParam (page, router, replace = false) {
    const url = parseUrl(window.location.href)
    if (url.query.page !== page.toString()) {
        url.query.page = page
        url.path = window.location.pathname
        if (replace) {
            router.replace(url)
        } else {
            router.push(url)
        }
    }
}



// WEBPACK FOOTER //
// ./resources/js/util/common.js